import { GameController, ChatsCircle, Trophy, MonitorPlay } from '@phosphor-icons/react';

export const DashboardPreview = () => {
  const mockGames = [
    { name: 'Valorant', genre: 'FPS', players: '125K', active: true },
    { name: 'League of Legends', genre: 'MOBA', players: '98K', active: false },
    { name: 'CS:GO', genre: 'FPS', players: '87K', active: false },
    { name: 'Fortnite', genre: 'Battle Royale', players: '134K', active: false },
  ];

  const mockMessages = [
    { user: 'ProGamer99', message: 'GG everyone! That was intense 🔥', time: '2:34 PM' },
    { user: 'NightOwl', message: 'Who wants to queue up?', time: '2:35 PM' },
    { user: 'StreamKing', message: 'Watching the tournament rn!', time: '2:36 PM' },
    { user: 'You', message: 'Count me in! 🎮', time: '2:37 PM', isOwn: true },
  ];

  const mockLeaderboard = [
    { rank: 1, name: 'xXEliteXx', score: '12,450' },
    { rank: 2, name: 'ProGamer99', score: '11,230' },
    { rank: 3, name: 'NightOwl', score: '10,890' },
    { rank: 4, name: 'You', score: '8,540', isYou: true },
  ];

  return (
    <div className="bg-white border border-[#E4E4E7] shadow-2xl overflow-hidden">
      {/* Top Bar */}
      <div className="bg-[#FAFAFA] border-b border-[#E4E4E7] px-4 py-2 flex items-center gap-2">
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-[#FF5F57]"></div>
          <div className="w-3 h-3 rounded-full bg-[#FFBD2E]"></div>
          <div className="w-3 h-3 rounded-full bg-[#28CA41]"></div>
        </div>
        <div className="flex-1 text-center">
          <span className="text-xs text-[#71717A]">DashLink Gaming - Dashboard</span>
        </div>
      </div>

      <div className="flex h-[400px]">
        {/* Games Sidebar */}
        <div className="w-56 border-r border-[#E4E4E7] bg-white flex flex-col">
          <div className="p-3 border-b border-[#E4E4E7]">
            <div className="flex items-center gap-2 mb-3">
              <div className="bg-[#0047FF] p-1.5">
                <GameController size={16} weight="fill" color="#FFFFFF" />
              </div>
              <span className="font-heading text-sm font-bold text-[#09090B]">DashLink</span>
            </div>
            <div className="flex items-center gap-2 p-2 bg-[#FAFAFA] border border-[#E4E4E7]">
              <div className="w-8 h-8 bg-[#0047FF] rounded-full flex items-center justify-center text-white text-xs font-bold">Y</div>
              <div>
                <p className="text-xs font-medium text-[#09090B]">You <span className="text-[#0047FF]">(Admin)</span></p>
                <p className="text-[10px] font-mono text-[#71717A]">8,540 pts</p>
              </div>
            </div>
          </div>
          <div className="p-3 flex-1">
            <p className="text-[10px] font-medium text-[#71717A] uppercase tracking-wider mb-2">Active Games</p>
            <div className="space-y-1">
              {mockGames.map((game) => (
                <div
                  key={game.name}
                  className={`p-2 border text-left transition-colors ${
                    game.active
                      ? 'bg-[#0047FF] text-white border-[#0047FF]'
                      : 'bg-white border-[#E4E4E7] hover:bg-[#FAFAFA]'
                  }`}
                >
                  <p className={`text-xs font-medium ${game.active ? 'text-white' : 'text-[#09090B]'}`}>
                    {game.name}
                  </p>
                  <p className={`text-[10px] ${game.active ? 'text-white/80' : 'text-[#71717A]'}`}>
                    {game.genre} • {game.players} online
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Chat Panel */}
        <div className="flex-1 flex flex-col border-r border-[#E4E4E7]">
          <div className="p-3 border-b border-[#E4E4E7] flex items-center justify-between">
            <div>
              <h3 className="text-sm font-bold text-[#09090B]">Valorant</h3>
              <p className="text-[10px] text-[#71717A]">Tactical shooter</p>
            </div>
            <button className="flex items-center gap-1 px-2 py-1 bg-[#0047FF] text-white text-[10px]">
              <MonitorPlay size={12} weight="fill" />
              Watch Stream
            </button>
          </div>
          
          <div className="flex-1 p-3 space-y-2 overflow-hidden">
            {mockMessages.map((msg, i) => (
              <div
                key={`${msg.user}-${i}`}
                className={`p-2 border-l-2 ${
                  msg.isOwn ? 'bg-[#FAFAFA] border-[#0047FF]' : 'bg-white border-transparent'
                }`}
              >
                <div className="flex items-center gap-2">
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] font-bold ${
                    msg.isOwn ? 'bg-[#0047FF]' : 'bg-[#71717A]'
                  }`}>
                    {msg.user[0]}
                  </div>
                  <span className="text-xs font-medium text-[#09090B]">{msg.user}</span>
                  <span className="text-[10px] font-mono text-[#71717A]">{msg.time}</span>
                </div>
                <p className="text-xs text-[#09090B] mt-1 ml-8">{msg.message}</p>
              </div>
            ))}
          </div>

          <div className="p-3 border-t border-[#E4E4E7]">
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Type a message..."
                className="flex-1 px-3 py-2 text-xs border border-[#E4E4E7] bg-white"
                disabled
              />
              <button className="px-3 py-2 bg-[#0047FF] text-white text-xs">Send</button>
            </div>
          </div>
        </div>

        {/* Leaderboard */}
        <div className="w-52 bg-white flex flex-col">
          <div className="p-3 border-b border-[#E4E4E7]">
            <div className="flex items-center gap-2">
              <Trophy size={16} weight="fill" className="text-[#0047FF]" />
              <h3 className="text-sm font-bold text-[#09090B]">Leaderboard</h3>
            </div>
            <p className="text-[10px] text-[#71717A]">Top players worldwide</p>
          </div>
          <div className="p-3 space-y-1 flex-1">
            {mockLeaderboard.map((player) => (
              <div
                key={player.rank}
                className={`p-2 border flex items-center gap-2 ${
                  player.isYou
                    ? 'bg-[#0047FF] text-white border-[#0047FF]'
                    : 'bg-white border-[#E4E4E7]'
                }`}
              >
                <span className={`text-xs font-mono font-bold w-5 ${
                  player.isYou ? 'text-white' : player.rank <= 3 ? 'text-[#0047FF]' : 'text-[#71717A]'
                }`}>
                  #{player.rank}
                </span>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] font-bold ${
                  player.isYou ? 'bg-white/20' : 'bg-[#71717A]'
                }`}>
                  {player.name[0]}
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-xs font-medium truncate ${
                    player.isYou ? 'text-white' : player.rank <= 3 ? 'text-[#0047FF]' : 'text-[#09090B]'
                  }`}>
                    {player.name}
                  </p>
                  <p className={`text-[10px] font-mono ${
                    player.isYou ? 'text-white/80' : 'text-[#71717A]'
                  }`}>
                    {player.score} pts
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
